import { CheckBoxOutlineBlankRounded, CheckBoxRounded, IndeterminateCheckBoxRounded } from "@mui/icons-material";
import { Stack, styled, Typography } from "@mui/material";
import { TreeItem as MuiTreeItem, TreeItemProps } from "@mui/x-tree-view";
import React from "react";
import { ITreeItem } from "../models";

const TreeItem = styled(MuiTreeItem)`
  background-color: transparent !important;

  .MuiTreeItem-content {
    background-color: transparent !important;
  }
`;

interface IProps extends TreeItemProps {
  items: ITreeItem[];
  selectedItemIds: string[];
  onItemSelected: (itemId: string) => void;
}

const TreeViewItem = React.forwardRef((props: IProps, ref: React.Ref<HTMLLIElement>) => {
  const { items, selectedItemIds, onItemSelected, ...other } = props;

  function getIcon() {
    if (props.selectedItemIds.includes(props.itemId)) {
      return <CheckBoxRounded />;
    } else if (isDescendantSelected(props.itemId, props.items, props.selectedItemIds)) {
      return <IndeterminateCheckBoxRounded />;
    } else {
      return <CheckBoxOutlineBlankRounded />;
    }
  }

  function isDescendantSelected(parentItemId: string, items: ITreeItem[], selectedItemIds: string[]): boolean {
    const descendants = items.filter((x) => x.parentItemId === parentItemId);
    let result = false;

    for (var i = 0; i < descendants.length; i++) {
      result =
        result ||
        selectedItemIds.includes(descendants[i].itemId) ||
        isDescendantSelected(descendants[i].itemId, items, selectedItemIds);

      if (result) {
        break;
      }
    }

    return result;
  }

  return (
    <TreeItem
      ref={ref}
      {...other}
      label={
        <Stack
          direction="row"
          spacing={0.25}
          sx={{ alignItems: "center" }}
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation();
            onItemSelected(props.itemId);
          }}
        >
          {getIcon()}
          <Typography>{props.label}</Typography>
        </Stack>
      }
    />
  );
});

export { TreeViewItem };
